import { create } from 'zustand'
import { ISpinStore } from '../../spin/store/spinStore'
import { MultiplierInfo } from '../../gameInfo/api/GameInfoResponse'
import { subscribeWithSelector } from 'zustand/middleware'
import { GameResultResponse, SlotSymbolInfo, WinReelResult } from '../../placeOrder/api/PlaceOrderResponse'
import { FreeGameType } from '../../buybonus/enum/buyBonusEnum'

interface IGameResult {
  mainGame: GameResultResponse
  totalPayout: number
  freeGame: GameResultResponse[]
}

interface IGameStore extends ISpinStore<SlotSymbolInfo> {
  payTable: IPayTableMap
  gameResult: IGameResult
  isShowLoading: boolean
  freeGameSpinCurrentIndex: number
  dropCurrentIndex: number
  currentOriginPayout: number
  currentPayout: number
  currentNormalTable: SlotSymbolInfo[][]
  currentDropTable: SlotSymbolInfo[][]
  currentWinningReel: WinReelResult[]
  currentMultiplier: number
  defaultReelTable: SlotSymbolInfo[][]
  multiplierReelInfo: MultiplierInfo | null
  spinAccumulatedPayout: number
  freeGameAccumulatedPayout: number
  finalBalance: number
  isFreeGame: boolean
  scatterCount: number
  currentFreeGameType: FreeGameType
  freeGameCount: number
  baseFreeGameCount: number
  bonusFreeGameCount: number
  isAnteBet: boolean
  isShakeing: boolean
  isThisSpinInSpeedMode: boolean
  isDisableEmergencyStop: boolean
  getMultiplierArray: () => number[]
  isFirstFreeSpin: () => boolean
  isPeek: () => boolean
  isWinScatter: () => boolean
  freeGameType: FreeGameType
  isLoadedAssets: boolean
  isShowPlaceOrderLoadingIcon: boolean
  isVoucherTime: boolean
}
export const defaultTable = [
  [
    {
      symbol: 10,
      multiplier: 0,
    },
    {
      symbol: 10,
      multiplier: 0,
    },
    {
      symbol: 9,
      multiplier: 0,
    },
    {
      symbol: 9,
      multiplier: 0,
    },
    {
      symbol: 7,
      multiplier: 0,
    },
  ],
  [
    {
      symbol: 5,
      multiplier: 0,
    },
    {
      symbol: 5,
      multiplier: 0,
    },
    {
      symbol: 9,
      multiplier: 0,
    },
    {
      symbol: 9,
      multiplier: 0,
    },
    {
      symbol: 3,
      multiplier: 0,
    },
  ],
  [
    {
      symbol: 7,
      multiplier: 0,
    },
    {
      symbol: 7,
      multiplier: 0,
    },
    {
      symbol: 4,
      multiplier: 0,
    },
    {
      symbol: 4,
      multiplier: 0,
    },
    {
      symbol: 8,
      multiplier: 0,
    },
  ],
  [
    {
      symbol: 11,
      multiplier: 0,
    },
    {
      symbol: 11,
      multiplier: 0,
    },
    {
      symbol: 7,
      multiplier: 0,
    },
    {
      symbol: 7,
      multiplier: 0,
    },
    {
      symbol: 5,
      multiplier: 0,
    },
  ],
  [
    {
      symbol: 11,
      multiplier: 0,
    },
    {
      symbol: 11,
      multiplier: 0,
    },
    {
      symbol: 4,
      multiplier: 0,
    },
    {
      symbol: 4,
      multiplier: 0,
    },
    {
      symbol: 10,
      multiplier: 0,
    },
  ],
  [
    {
      symbol: 10,
      multiplier: 0,
    },
    {
      symbol: 10,
      multiplier: 0,
    },
    {
      symbol: 9,
      multiplier: 0,
    },
    {
      symbol: 9,
      multiplier: 0,
    },
    {
      symbol: 11,
      multiplier: 0,
    },
  ],
]

export const initMainGameResult = {
  normalResult: {
    dropTable: [
      [
        {
          symbol: 7,
          multiplier: 0,
        },
        {
          symbol: 7,
          multiplier: 0,
        },
        {
          symbol: 4,
          multiplier: 0,
        },
        {
          symbol: 4,
          multiplier: 0,
        },
        {
          symbol: 8,
          multiplier: 0,
        },
      ],
      [
        {
          symbol: 11,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
        {
          symbol: 6,
          multiplier: 0,
        },
        {
          symbol: 6,
          multiplier: 0,
        },
      ],
      [
        {
          symbol: 3,
          multiplier: 0,
        },
        {
          symbol: 9,
          multiplier: 0,
        },
        {
          symbol: 9,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
      ],
      [
        {
          symbol: 11,
          multiplier: 0,
        },
        {
          symbol: 11,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
      ],
      [
        {
          symbol: 5,
          multiplier: 0,
        },
        {
          symbol: 5,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
        {
          symbol: 10,
          multiplier: 0,
        },
        {
          symbol: 7,
          multiplier: 0,
        },
      ],
      [
        {
          symbol: 3,
          multiplier: 0,
        },
        {
          symbol: 11,
          multiplier: 0,
        },
        {
          symbol: 11,
          multiplier: 0,
        },
        {
          symbol: 7,
          multiplier: 0,
        },
        {
          symbol: 7,
          multiplier: 0,
        },
      ],
    ],
    winningReels: [],
    multiplier: 0,
  },
  dropResults: [
    {
      dropTable: [
        [
          {
            symbol: 7,
            multiplier: 0,
          },
          {
            symbol: 7,
            multiplier: 0,
          },
          {
            symbol: 4,
            multiplier: 0,
          },
          {
            symbol: 4,
            multiplier: 0,
          },
          {
            symbol: 8,
            multiplier: 0,
          },
        ],
        [
          {
            symbol: 11,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
          {
            symbol: 6,
            multiplier: 0,
          },
          {
            symbol: 6,
            multiplier: 0,
          },
        ],
        [
          {
            symbol: 3,
            multiplier: 0,
          },
          {
            symbol: 9,
            multiplier: 0,
          },
          {
            symbol: 9,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
        ],
        [
          {
            symbol: 11,
            multiplier: 0,
          },
          {
            symbol: 11,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
        ],
        [
          {
            symbol: 5,
            multiplier: 0,
          },
          {
            symbol: 5,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
          {
            symbol: 10,
            multiplier: 0,
          },
          {
            symbol: 7,
            multiplier: 0,
          },
        ],
        [
          {
            symbol: 3,
            multiplier: 0,
          },
          {
            symbol: 11,
            multiplier: 0,
          },
          {
            symbol: 11,
            multiplier: 0,
          },
          {
            symbol: 7,
            multiplier: 0,
          },
          {
            symbol: 7,
            multiplier: 0,
          },
        ],
      ],
      winningReels: [],
      multiplier: 0,
    },
  ],
  freeGameType: 0,
  totalMultiplier: 0,
  multiplierReel: {
    startMultiplier: 0,
    intervalValue: 0,
  },
}

export const useGameStore = create<IGameStore>()(
  subscribeWithSelector<IGameStore>(
    (_, get): IGameStore => ({
      payTable: {
        M1: {
          12: 3,
          10: 1.5,
          8: 0.6,
        },
        M2: {
          12: 2,
          10: 1,
          8: 0.5,
        },
        M3: {
          12: 1.5,
          10: 0.8,
          8: 0.4,
        },
        M4: {
          12: 1.2,
          10: 0.7,
          8: 0.35,
        },
        M5: {
          12: 1,
          10: 0.6,
          8: 0.3,
        },
        A: {
          12: 0.8,
          10: 0.5,
          8: 0.25,
        },
        K: {
          12: 0.7,
          10: 0.4,
          8: 0.2,
        },
        Q: {
          12: 0.5,
          10: 0.3,
          8: 0.15,
        },
        J: {
          12: 0.4,
          10: 0.2,
          8: 0.1,
        },
      },
      gameResult: {
        mainGame: initMainGameResult,
        totalPayout: 0,
        freeGame: [],
      },
      isShowLoading: true,
      freeGameAccumulatedPayout: 0,
      spinAccumulatedPayout: 0,
      freeGameSpinCurrentIndex: 0,
      dropCurrentIndex: 0,
      currentOriginPayout: 0,
      currentPayout: 0,
      currentNormalTable: [],
      currentDropTable: [],
      currentWinningReel: [],
      currentMultiplier: 0,
      defaultReelTable: defaultTable,
      multiplierReelInfo: {
        intervalValue: 5,
        startMultiplier: 5,
      },
      finalBalance: 0,
      isFreeGame: false,
      scatterCount: 0,
      currentFreeGameType: 0,
      freeGameCount: 0,
      baseFreeGameCount: 0,
      bonusFreeGameCount: 0,
      isAnteBet: false,
      freeGameType: FreeGameType.MainGame,
      isShakeing: false,
      isThisSpinInSpeedMode: false,
      isDisableEmergencyStop: false,
      getMultiplierArray: () => {
        const store = get()
        if (store.multiplierReelInfo) {
          const { intervalValue } = store.multiplierReelInfo
          const multiplierReelArry: number[] = []
          for (let i = 1; i <= 7; i++) {
            multiplierReelArry.push(i * intervalValue)
          }
          return multiplierReelArry // default is C
        }
        return []
      },
      isFirstFreeSpin: () => {
        return get().freeGameSpinCurrentIndex === 0
      },
      isPeek: () => {
        const { isFreeGame, scatterCount } = get()
        return (isFreeGame && scatterCount >= 2) || (!isFreeGame && scatterCount >= 3)
      },
      isWinScatter: () => {
        const { isFreeGame, scatterCount } = get()
        return (isFreeGame && scatterCount >= 3) || (!isFreeGame && scatterCount >= 4)
      },
      isLoadedAssets: false,
      isShowPlaceOrderLoadingIcon: false,
      isVoucherTime: false,
    }),
  ),
)

export interface IPayTableMap {
  [key: string]: {
    [innerKey: string]: number
  }
}
